export default "__VITE_ASSET__fb8efb5a__"